class converter {
    static getCodeByName(name) {
        return this.types[name]
    }

    static getCodeByFullname(fullname) {
        const name = fullname.split(" ").slice(0, -1).join(" ")
        return this.types[name]
    }

    static getNameByCode(code) {
        return Object.keys(this.types).find(key => this.types[key] === code)
    }

    static getFullnameByCode(code) {
        return Object.keys(this.types).find(key => this.types[key] === code) + (this.end || "")
    }
}

class CE_approaches extends converter {
    static types =
    {
        "Сравнительный" : "comparative",
        "Затратный" : "expensive",
        "Доходный" : "profitable",
        "Индивидуальный" : "individual",
    }

    static end = " подход"
}

class CE_methods extends converter {
    static types =
    {
        "Метод статистического (регрессионного) моделирования" : "modeling",
        "Метод сравнительной единицы" : "comparative_element",
        "Метод прямой капитализации" : "capitalization",
    }
}

class CE_modeling_model extends converter {
    static types =
    {
        "Линейная" : "add",
        "Мультипликативная степенная" : "mult",
        "Экспоненциальная" : "exp",
    }

    static end = " модель"
}

class periods
{
    static types = {
        daily : {
            label : 'Ежесуточно',
            max : 365,
            simple : 'Сутки'
        },
    
        weekly : {
            label : 'Еженедельно',
            max : 52,
            simple : 'Неделя'
        },
    
        monthly : {
            label : 'Ежемесячно',
            max : 12,
            simple : 'Месяц'
        },
    
        quarterly : {
            label : 'Ежеквартально',
            max : 4,
            simple : 'Квартал'
        },
    
        annually : {
            label : 'Ежегодно',
            max : 1,
            simple : 'Год'
        }
    }

    static getBySimple(simple)
    {
        return Object.values(this.types).find((type) => type.simple === simple)
    }
}

export default {
    CE_approaches,
    CE_methods,
    CE_modeling_model,
    periods
}
